/**
 * A row held by value, a synthetic one among them, has no share count and no unit price: in the review
 * both cells read "N/A" with a tooltip saying why, as in the quantity editor and its proposal view.
 */
import type { ColDef } from "ag-grid-community";
import i18n from "i18next";
import { withNotAvailableCell } from "$root/functional-areas/instruments-editor/quantity/not-available/withNotAvailableCell";
import type { QuantityReviewRow } from "./rows";

function reasonKey(colId: string | undefined) {
	switch (colId) {
		case "QUANTITY":
			return "TABLE.QUANTITY_PROPOSAL.NA.HELD_BY_VALUE" as const;
		case "MARKET_PRICE":
			return "TABLE.QUANTITY.NA.HELD_BY_VALUE_PRICE" as const;
		default:
			return undefined;
	}
}

export function withHeldByValueCells(columns: ColDef<QuantityReviewRow>[]): ColDef<QuantityReviewRow>[] {
	return columns.map((column) => {
		const key = reasonKey(column.colId);
		if (!key) {
			return column;
		}
		return withNotAvailableCell(column, (row) => (row.heldByValue ? i18n.t(key) : undefined));
	});
}
